import React from 'react';
import CustomInput from '../../form/CustomInput';
import { CheckboxItem } from '../../listing/ColumnIdentifier';
import { FieldLabel } from './FieldSettingsModal';
import { useTheme } from '../../../middleware/ThemeContext';
import CustomTextArea from '../../form/CustomTextArea';

export const FieldLabelSettings: React.FC<{
  fieldLabel: string;
  setFieldLabel: (value: string) => void;
  hideLabel: boolean;
  setHideLabel: (value: boolean) => void;
}> = ({ fieldLabel, setFieldLabel, hideLabel, setHideLabel }) => {
  const { theme } = useTheme();
  return (
    <div className="px-3 py-2">
      <FieldLabel theme={theme}>
        Boolean Field Text
      </FieldLabel>
      <CustomTextArea
        value={fieldLabel}
        onChange={setFieldLabel}
        placeholder="Enter text which will displayed against the checkbox" />
      {/* <CheckboxItem theme={theme}>
      <input
        type="checkbox"
        checked={hideLabel}
        onChange={(e) => setHideLabel(e.target.checked)} />
      <FieldLabel theme={theme}>
        Hide Field Label
      </FieldLabel>
    </CheckboxItem> */}
    </div>
  );
};